import axios from 'axios'
import qs from 'qs'

import { url } from './constants'

const fileUrl = url + 'api/user/files'

const uploadFile = async image => {
  let response = {}
  const formData = new FormData()
  formData.append('file', image)
  await axios
    .post(fileUrl + '/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      },
      withCredentials: true
    })
    .then(res => {
      response = res.data
    })
    .catch(e => {
      response = { error: e.response?.data?.message }
    })

  return response
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  uploadFile
}
